import { render, staticRenderFns } from "./KentPolice.vue?vue&type=template&id=d8aae48e&scoped=true"
import script from "./KentPolice.vue?vue&type=script&lang=js"
export * from "./KentPolice.vue?vue&type=script&lang=js"
import style0 from "./KentPolice.vue?vue&type=style&index=0&id=d8aae48e&prod&scoped=true&lang=css"
import style1 from "./KentPolice.vue?vue&type=style&index=1&id=d8aae48e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8aae48e",
  null
  
)

export default component.exports